module.exports = __webpack_public_path__ + "static/media/nosmoking.7c826e45.png";